<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 10/10/2020
  -->

<template>
	<div class="program-item-root">
		<el-card shadow="hover"
				 class="program-card fill-height relative">

			<h5 class="card-title">{{ program.headingTitle }}</h5>
			<h6 class="card-subtitle mb-4">{{ program.name }}</h6>
			<div class="text-muted mb-5">

				<small>
					<div><span>Next task: <b>{{ program.currentGoalFormatted() }}</b></span></div>
					<div class="mb-4">
						<span>Next session: <b><span :class="[program.nextSessionClass(currentUser.uid, currentUser.email)]">{{ program.nextSessionFormatted(currentUser.uid)}}</span></b></span>
					</div>
					<div class="">
						<span>Completed sessions: <b><span>{{ program.completedSessionCount()}} of {{ program.sessionCount()}}</span> </b></span>
					</div>
					<div v-if="program.billingAmountTotal > 0">
						<div>Earned: <span class="text-success">{{currencyFormatted(program.billingAmountPaid)}}</span> of {{currencyFormatted(program.billingAmountTotal)}}</div>
					</div>
				</small>
			</div>

			<div class="layout-spacer"></div>

			<div class="relative" style="min-height: 20px;">
				<small class="text-muted">{{ program.startedOnFormatted()}}</small>
				<span v-if="program.isClientEnabled" :class="[program.statusClass()]" class="badge badge-pill card-label">{{ program.statusText()}}</span>
				<span v-else class="badge badge-pill card-label badge-danger">Client disabled</span>
			</div>
		</el-card>
	</div>
</template>

<script>

    import CoachingProgram from "@shared/Program/CoachingProgram";


	import BaseComponent from "@/core/components/BaseComponent.vue";

	export default {
		extends: BaseComponent,
		name: "CoachingProcessListItem",
		components: {},
		props: {
			program: {type: CoachingProgram},
			index: Number,
		},

		created() {
		},

		computed: {
		},


		methods: {

		},

	}
</script>

<style lang="scss">
	.program-item-root{
		//height: calc(100% - 30px);
		margin-top: 15px;
		margin-bottom: 15px;

		.el-card__body{
			padding: 0;
			display: flex;
			flex-direction: column;
			flex: 1;
		}
		.program-card{
			padding: 25px;
			min-height: 220px;
			cursor: pointer;
		}

		.card-title{
			font-weight: 600;
		}

		.card-subtitle{
			font-weight: 500;
		}

		.card-label {
			position: absolute;
			border-bottom-right-radius: 0 !important;
			border-top-right-radius: 0  !important;;
			bottom: auto;
			top: auto;
			right: -25px;
		}
	}

</style>
